<template>
	<el-dialog
		title="新增伙伴"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-form ref="formRef" :model="form" :rules="rules" size="small">
			<el-row :gutter="16">
				<!-- 项目编号 -->
				<el-col :span="12">
					<el-form-item label="项目编号" prop="projectCode">
						<el-input v-model="form.projectCode" disabled />
					</el-form-item>
				</el-col>

				<!-- 项目名称 -->
				<el-col :span="12">
					<el-form-item label="项目名称" prop="projectName">
						<el-input v-model="form.projectName" placeholder="请输入项目名称" />
					</el-form-item>
				</el-col>

				<!-- 所属小区 -->
				<el-col :span="12">
					<el-form-item label="所属小区" prop="community">
						<el-select v-model="form.community" placeholder="请选择所属小区" style="width: 100%">
							<el-option label="南京软件谷项目" value="南京软件谷项目" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 经营类型 -->
				<el-col :span="12">
					<el-form-item label="经营类型" prop="businessType">
						<el-select v-model="form.businessType" placeholder="请选择经营类型" style="width: 100%">
							<el-option label="创新租赁" value="创新租赁" />
							<el-option label="委托租售" value="委托租售" />
							<el-option label="增值服务" value="增值服务" />
							<el-option label="房产经纪" value="房产经纪" />
							<el-option label="其他" value="其他" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 关联资产 -->
				<el-col :span="12">
					<el-form-item label="关联资产" prop="assets">
						<el-select v-model="form.assets" multiple placeholder="请选择关联资产" style="width: 100%">
							<el-option label="A栋1层广告位" value="A栋1层广告位" />
							<el-option label="A栋2层广告位" value="A栋2层广告位" />
							<el-option label="B栋301室" value="B栋301室" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 预计收入 -->
				<el-col :span="12">
					<el-form-item label="预计收入" prop="expectedIncome">
						<el-input
							type="number"
							v-model.number="form.expectedIncome"
							:min="0"
							style="width: 100%"
							placeholder="请输入预计收入"
							class="no-spinner" />
					</el-form-item>
				</el-col>

				<!-- 开始日期 -->
				<el-col :span="12">
					<el-form-item label="开始日期" prop="startDate">
						<el-date-picker v-model="form.startDate" type="date" placeholder="请选择开始日期" style="width: 100%" />
					</el-form-item>
				</el-col>

				<!-- 结束日期 -->
				<el-col :span="12">
					<el-form-item label="结束日期" prop="endDate">
						<el-date-picker v-model="form.endDate" type="date" placeholder="请选择结束日期" style="width: 100%" />
					</el-form-item>
				</el-col>

				<!-- 备注 -->
				<el-col :span="24">
					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- footer -->
		<template #footer>
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ProjectManagementAddDialog',
		props: {
			dialogVisible: Boolean,
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					projectCode: 'XM-20260423-0005',
					projectName: '',
					community: '',
					businessType: '',
					assets: [],
					expectedIncome: '',
					startDate: '',
					endDate: '',
					remark: '',
				},
				rules: {
					projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
					community: [{ required: true, message: '请选择所属小区', trigger: 'change' }],
					businessType: [{ required: true, message: '请选择经营类型', trigger: 'change' }],
					assets: [{ required: true, message: '请选择关联资产', trigger: 'change' }],
					expectedIncome: [{ required: true, message: '请输入预计收入', trigger: 'blur' }],
					startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
					endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
				},
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.cards {
		margin-bottom: 20px;
	}
</style>
